import React, { memo } from 'react';
import { BettyCoinLoader, Box, Text } from '@betty/moonlight';
import { RegistrationLoaderProps } from './RegistrationLoader.types';

function RegistrationLoader({
  titleNS,
  titleKey,
  descriptionNS,
  descriptionKey,
  ...rest
}: RegistrationLoaderProps) {
  const { variant, gradient, ...boxProps } = rest;

  return (
    <Box flex={1} alignItems="center" justifyContent="center" {...boxProps}>
      <Box width={80} height={80} marginBottom="space-600">
        <BettyCoinLoader />
      </Box>
      <Box alignItems="center">
        {titleNS && titleKey ? (
          <Text
            variant="h3"
            color="darkSurfacePrimary"
            locNS={titleNS}
            locKey={titleKey}
            marginBottom="space-300"
            textAlign="center"
          ></Text>
        ) : null}
        {descriptionNS && descriptionKey ? (
          <Text
            variant="h6"
            color="darkSurfacePrimary"
            locNS={descriptionNS}
            locKey={descriptionKey}
            marginBottom="space-300"
            textAlign="center"
          ></Text>
        ) : null}
      </Box>
    </Box>
  );
}
export default memo(RegistrationLoader);
